import { Box, Flex } from "@chakra-ui/react";

interface Props {
  children: React.ReactNode;
}

export default function LandingContent({ children }: Props) {
  return (
    <Flex my={10} mx={5} alignItems={"center"} flexDirection={"column"}>
      <Box maxWidth={"800px"}>{children}</Box>
    </Flex>
  );
}
